import { post } from '../service/request'
/**
 * 获取公司简介或资质荣誉
 * @param {Number} parkType 1 资质荣誉 2 公司简介
 * @return  {Promise}
 */
export const getYQGKDetail = (parkType = 1) => {
	const params = {
		parktype: parkType,
	}
	return post('/kxHonour/getKxHonour', params)
}
